/**
 * Gets the current geolocation coordinates
 * @returns {Promise<{latitude: number|null, longitude: number|null}>}
 */
export const getLocation = () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            resolve({ latitude: null, longitude: null });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.warn('Geolocation error:', error);
                resolve({ latitude: null, longitude: null });
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        );
    });
};